import React from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";

const ContactForm = ({
  handleClose,
  handleSubmit: onSubmit,
  initialData,
  isEditing,
}) => {
  const [hotels, setHotels] = React.useState([]);
  const departments = [
    "GENERAL",
    "RESERVATIONS",
    "SALES",
    "EVENTS",
    "ACCOUNTING",
  ];
  const isPrimaryOptions = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];

  React.useEffect(() => {
    const fetchHotels = async () => {
      try {
        const response = await fetch("https://api.esthell.com/Hotel");
        if (response.ok) {
          const data = await response.json();
          if (data.success && Array.isArray(data.data)) {
            setHotels(data.data);
          }
        }
      } catch (error) {
        console.error("Error fetching hotels:", error);
      }
    };
    fetchHotels();
  }, []);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: initialData || {
      contact_id: "",
      hotel_id: "",
      department: "",
      name: "",
      position: "",
      email: "",
      phone: "",
      is_primary: false,
    },
  });

  return (
    <Box
      component="form"
      sx={{ p: 3, bgcolor: "background.paper", borderRadius: 2, boxShadow: 1 }}
    >
      <Typography
        variant="h6"
        sx={{ mb: 2, color: "#1a237e", fontWeight: "bold" }}
      >
        {isEditing ? "Update Contact" : "Add Contact"}
      </Typography>

      <Grid container spacing={2}>
        //{" "}
        <Grid item xs={12} sm={6}>
          {/* <Controller
            name="contact_id"
            control={control}
            rules={{ required: "Contact ID is required" }}
            render={({ field }) => (
              <TextField 
                {...field} 
                label="Contact ID" 
                type="number"
                fullWidth 
                size="small"
                error={!!errors.contact_id}
                helperText={errors.contact_id?.message}
              />
            )}
          /> */}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="hotel_id"
            control={control}
            rules={{ required: "Hotel is required" }}
            render={({ field }) => (
              <FormControl fullWidth size="small">
                <InputLabel>Hotel Name</InputLabel>
                <Select {...field} label="Hotel Name" error={!!errors.hotel_id}>
                  <MenuItem value="">
                    <em>Select Hotel</em>
                  </MenuItem>
                  {hotels.map((hotel) => (
                    <MenuItem key={hotel.id} value={hotel.hotel_id}>
                      {hotel.name} : {hotel.hotel_id}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="department"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                select
                label="Department"
                fullWidth
                size="small"
              >
                {departments.map((dept) => (
                  <MenuItem key={dept} value={dept}>
                    {dept}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="name"
            control={control}
            rules={{ required: "Name is required" }}
            render={({ field }) => (
              <TextField
                {...field}
                label="Name"
                fullWidth
                size="small"
                error={!!errors.name}
                helperText={errors.name?.message}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="position"
            control={control}
            render={({ field }) => (
              <TextField {...field} label="Position" fullWidth size="small" />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="email"
            control={control}
            rules={{
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Invalid email address",
              },
            }}
            render={({ field }) => (
              <TextField
                {...field}
                label="Email"
                type="email"
                fullWidth
                size="small"
                error={!!errors.email}
                helperText={errors.email?.message}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="phone"
            control={control}
            render={({ field }) => (
              <TextField {...field} label="Phone" fullWidth size="small" />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="is_primary"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                select
                label="Is Primary Contact"
                fullWidth
                size="small"
              >
                {isPrimaryOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </Grid>
      </Grid>

      <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", mt: 2 }}>
        <Button onClick={handleClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleSubmit(onSubmit)}
          variant="contained"
          color="primary"
        >
          {initialData ? "Update" : "Save"}
        </Button>
      </Box>
    </Box>
  );
};

export default ContactForm;
